var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiploma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "diploma_x5F_logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 241",
    style: {
      enableBackground: "new 0 0 900 241"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4E52A2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.2,47.7c-40.3,0-73.1,32.8-73.1,72.5c0,40.3,32.8,73.1,73.1,73.1c39.8,0,72.5-32.8,72.5-73.1 C553.7,80.5,521,47.7,481.2,47.7z M497.9,142.5l-8.8-15.8l9.8-3c0.7-0.2,0.8-1.1,0.3-1.5L469.8,101c-0.6-0.4-1.4,0-1.4,0.8 l2.6,36.1c0.1,0.7,0.9,1.1,1.4,0.6l7.7-6.8l8.8,15.8l-35,19.6L453.7,74l79.3,48.9L497.9,142.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.9,63.3C93.2,54,81.5,47.6,64.7,47.6C25.8,47.6,0,80.3,0,120.1c0,40.3,25.8,73.1,64.7,73.1 c16.8,0,28.6-6.2,37.2-15.4v12.6h40.6V0h-40.6V63.3z M101.9,137.5c-5.9,9-19.3,17.9-31.4,17.9c-20.4,0-28.6-18.8-28.6-35.3 c0-16.8,8.1-34.7,28.6-34.7c12,0,25.2,8.4,31.4,17.6V137.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 50.4,
    className: "st0",
    width: 40.6,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    className: "st0",
    width: 40.6,
    height: 36.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.9,47.6c-16.8,0-28.6,6.4-37.2,15.7V50.4h-40.6V241h40.6v-63.3c8.7,9.2,20.4,15.4,37.2,15.4 c38.9,0,64.7-32.8,64.7-73.1C353.6,80.3,327.8,47.6,288.9,47.6z M283,155.4c-12,0-25.5-9-31.4-17.9V103 c6.2-9.2,19.3-17.6,31.4-17.6c20.4,0,28.6,17.9,28.6,34.7C311.6,136.6,303.5,155.4,283,155.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.6,
    className: "st0",
    width: 40.6,
    height: 190.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M723.1,47.6c-19,0-34.2,8.7-45.1,21.8c-7.6-13.2-21-21.8-37.5-21.8s-29.1,6.7-39.2,16.8v-14h-40.6v140h40.6 V95.7c7.6-6.4,15.7-9.8,24.9-9.8c6.7,0,16,2,16,21v83.4h42v-96c7.6-5.6,16.5-8.4,24.6-8.4c6.7,0,16,2,16,21v83.4h42V92.9 C766.8,67.5,747.7,47.6,723.1,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M842.3,47.6c-24.4,0-44.8,5.6-61.6,23.5l18.5,26.3c7.6-6.7,21.6-16.2,35-16.2c12.3,0,25.2,5.3,25.2,20.7v4.2 l-30,0.3c-31.4,0-55.7,14-55.7,43.7c0,30,22.4,43.1,48.4,43.1c16,0,27.4-5,37.2-12.9v10.1H900V95.5C900,66.3,873.1,47.6,842.3,47.6 z M859.4,148.1c-6.4,8.1-13.4,13.4-25.5,13.4c-9.8,0-18.2-4.2-18.2-14.6c0-10.4,8.7-13.4,18.5-13.4h25.2V148.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiploma);
export default __webpack_public_path__ + "static/media/diploma.165ef2fbd670fc7e17c7c0287f937855.svg";
export { ForwardRef as ReactComponent };